import axios from "axios";
import { ApiUrl } from "../utils/modules";
import { header } from "../utils/modules";

class UsageServices {
  getAll() {
    return axios.get(ApiUrl + "usage", header());
  }

  getByComputerName(computerName) {
    return axios.get(ApiUrl + `usage?computerName=${computerName}`);
  }

  create(data) {
    return axios.post(ApiUrl + "usage", data);
  }

  createMany(data) {
    return axios.post(ApiUrl + "usage/insert/many", data);
  }

  getByDateRange(startDate, endDate) {
    return axios.get(
      ApiUrl + `usage?createdAt[gte]=${startDate}&createdAt[lte]=${endDate}`
    );
  }

  delete(id) {
    return axios.delete(ApiUrl + `usage/${id}`);
  }

  updateUsageComputer(id, data) {
    return axios.put(ApiUrl + `usage/${id}`, data);
  }
}

export default new UsageServices();
